import { defineNuxtPlugin } from 'nuxt/app';
import VueEasyLightbox from 'vue-easy-lightbox';

export default defineNuxtPlugin(nuxt => {
  nuxt.vueApp.component('PulseLightbox', VueEasyLightbox);
});
